import SplashScreen from './splash_screen';

export default SplashScreen;
